module.exports = __webpack_public_path__ + "img/homepro3.2f622d5d.png";